import { manifest, type Manifest } from "@upstart.gg/sdk/bricks/manifests/card.manifest";
import type { BrickProps } from "@upstart.gg/sdk/shared/bricks/props/types";
import TextContent from "../components/TextContent";
import { tx, css } from "@upstart.gg/style-system/twind";
import { useBrickStyle } from "../hooks/use-brick-style";
import BrickRoot from "../components/BrickRoot";
import { useBrickProps } from "../hooks/use-brick-props";
import { useState } from "react";

export default function Card(props: BrickProps<Manifest>) {
  const { brick, editable } = props;
  const brickProps = useBrickProps(props);
  const styles = useBrickStyle<Manifest>(brick);
  const classes = Object.values(styles);
  const [showImage, setShowImage] = useState(true);
  return (
    <BrickRoot
      brick={brick}
      editable={editable}
      manifest={manifest}
      className={tx("flex relative overflow-hidden !flex-nowrap flex-col", classes)}
    >
      <div className={tx("card-inner-wrapper", brickProps.imagePosition === "top" ? "order-2" : "order-1")}>
        {!brickProps.noTitle && (
          <div className={tx("text-[120%] font-semibold z-auto my-4 mx-4")}>
            <TextContent
              propPath="title.content"
              className={tx("flex-1")}
              brickId={brick.id}
              content={brickProps.title}
              rawContent={brick.props.title}
              editable={editable}
              inline
            />
          </div>
        )}
        {brickProps.imagePosition !== "middle" && (
          <div className={tx("z-auto p-4", !brickProps.noTitle && "pt-0")}>
            <TextContent
              propPath="text.content"
              className={tx("flex-grow")}
              brickId={brick.id}
              content={brickProps.text}
              rawContent={brick.props.text}
              editable={editable}
            />
          </div>
        )}
      </div>
      {brickProps.cardImage?.src && showImage && (
        <img
          onError={() => setShowImage(false)}
          className={tx(
            " select-none pointer-events-none bg-transparent w-inherit h-[clamp(100px,50%,250px)]",
            brickProps.cardImage.position ?? "object-center",
            brickProps.cardImage.fit ?? "object-cover",
            brickProps.imagePosition === "middle" && "order-2",
            brickProps.imagePosition === "top" && "order-first",
            brickProps.imagePosition === "bottom" && "order-last mt-auto",
          )}
          src={brickProps.cardImage.src}
          alt={brickProps.cardImage.alt || "Card Image"}
        />
      )}
      {brickProps.text && brickProps.imagePosition === "middle" && (
        <div className={tx("z-auto p-4 order-last")}>
          <TextContent
            propPath="text.content"
            className={tx("flex-1 prose lg:prose-lg")}
            brickId={brick.id}
            content={brickProps.text}
            rawContent={brick.props.text}
            editable={editable}
          />
        </div>
      )}
    </BrickRoot>
  );
}
